import React, {useContext, useEffect, useState, useRef} from "react";
import { MapContainer } from "react-leaflet";

const HulpstukChart = ({data, serialNumber}) => {
  const containerRef = useRef(null);
  const canvasRef = useRef(null);

  const draw = () => {
    if (!canvasRef && canvasRef.current) return;
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");

    const rect = canvas.getBoundingClientRect()

    canvas.width = rect.width * 2;
    canvas.height = rect.height * 2;

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    ctx.beginPath()
    ctx.strokeStyle = "#f00"

    const dataList = Object.values(data)

    const maxValue = Math.max(...dataList) / canvas.height
    const widthValue = canvas.width / (dataList.length - 1)

    ctx.moveTo(0, dataList[0] / maxValue)

    dataList.shift()

    dataList.forEach((value, i) => {
      ctx.lineTo((i + 1) * widthValue, value / maxValue)
    })

    ctx.stroke()
  }

  useEffect(() => {
    if (data) draw()
  }, [data, serialNumber])

  return (
    <canvas className="h-12 w-7/12 border" ref={canvasRef}/>
  )
}

export default HulpstukChart;